import Vue from 'vue'
import store from './store'
import Router from 'vue-router'
import * as R from 'ramda'
import Home from './views/Home'
import Login from './views/Login'
import Register from './views/Register'
import Shops from './views/Shops'
import AdShops from './views/AdShops'
import Shop from './views/Shop'
import Buy from './views/Buy'
import Set from './views/Set'
import Task from './views/Task'
import OrderList from './views/OrderList'
import Order from './views/Order'
import Transport from './views/Transport'
import Profile from './views/Profile'
import Addresses from './views/Addresses'
import Address from './views/Address'
import Agreements from './views/Agreements'
import Coupons from './views/Coupons'
import Elastic from './views/Elastic'
import Score from './views/Score'
import ShopList from './views/shop/List'
import BrandShops from './views/shop/BrandShops'
import Suggest from './views/shop/Suggest'
import Timeline from './views/Timeline'
import OrderEdit from './views/OrderEdit'
import Notices from './views/Notices'
import Checkout from './views/Checkout'
import LIFF from './LIFF'
import Queue from './views/Queue'
import Payment from './views/Payment'
import Search from './views/shop/Search'
import Wash from './views/Wash'
import LiquorShop from "./views/LiquorShop";
import Liquor from "./views/Liquor";
import Designate from "./views/Designate";
import DriverList from "./views/components/designate/DriverList";
import DesignateOrderList from "./views/components/designate/OrderList";
import Share from "./views/Share";
import ShareFail from "./views/ShareFail";
import Recommend from "./views/Recommend";
import Message from "./views/Message";
import Help from "./views/Help";
import Cancel from "./views/Cancel";
import Activities from "./views/Activities";
import Pay from "./views/Pay";
import Accompanying from "./views/Accompanying";
import Housekeeping from "./views/Housekeeping";

Vue.use(Router)

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  }

  const position = {};
  if (to.hash) {
    position.selector = to.hash;
  }
  if (to.matched.some(route => route.meta.scrollToTop)) {
    position.x = 0;
    position.y = 0;
  }

  return position;
};

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/agreements',
      name: 'agreements',
      component: Agreements,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/addresses/edit/:id?',
      name: 'address',
      component: Address,
      meta: {
        scrollToTop: true
      }
    },
    {
      path: '/addresses',
      name: 'addresses',
      component: Addresses,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/shops/list',
      name: 'ShopList',
      component: ShopList,
      meta: {
        scrollToTop: true,
        keepAlive: true,
      }
    },
    {
      path: '/shops/search',
      name: 'search',
      component: Search,
      meta: {
        scrollToTop: true,
        keepAlive: true,
      }
    },
    {
      path: '/shops',
      name: 'shops',
      component: Shops,
      meta: {
        scrollToTop: true
      },
    },
    {
      path: '/shops/:id',
      name: 'shop',
      component: Shop,
      meta: {
        scrollToTop: true
      }
    },
    {
      path: '/brands/:id/shops',
      name: 'BrandShops',
      component: BrandShops,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/ad/:id',
      name: 'AdShops',
      component: AdShops,
      meta: {
        scrollToTop: true
      }
    },
    {
      path: '/buy',
      name: 'buy',
      component: Buy,
      meta: {
        scrollToTop: true,
        createOrderPage: true,
      }
    },
    {
      path: '/pay',
      name: 'pay',
      component: Pay,
      meta: {
        scrollToTop: true,
        createOrderPage: true,
      }
    },
    {
      path: '/set',
      name: 'set',
      component: Set,
      meta: {
        scrollToTop: true,
        createOrderPage: true,
      }
    },
    {
      path: '/transport',
      name: 'transport',
      component: Transport,
      meta: {
        scrollToTop: true,
        createOrderPage: true,
      }
    },
    {
      path: '/elastic',
      name: 'elastic',
      component: Elastic,
      meta: {
        scrollToTop: true,
        createOrderPage: true,
      }
    },
    {
      path: '/accompanying',
      name: 'accompanying',
      component: Accompanying,
      meta: {
        scrollToTop: true,
        createOrderPage: true,
      }
    },
    {
      path: '/housekeeping',
      name: 'housekeeping',
      component: Housekeeping,
      meta: {
        scrollToTop: true,
        createOrderPage: true,
      }
    },
    {
      path:'/queue',
      name: 'wait',
      component: Queue,
      meta: {
        scrollToTop: true,
        createOrderPage: true,
      }
    },
    {
      path: '/wash',
      name: 'wash',
      component: Wash,
      meta: {
        scrollToTop: true,
        createOrderPage: true,
      }
    },
    {
      path: '/liquor/shop',
      name: 'liquorShop',
      component: LiquorShop,
      meta: {
        scrollToTop: true,
        noDrive: true,
      }
    },
    {
      path: '/liquor',
      name: 'liquor',
      component: Liquor,
      meta: {
        scrollToTop: true,
        createOrderPage: true,
        noDrive: true,
      }
    },
    {
      path:'/:type/designate',
      name:'designate',
      component: Designate,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path:'/:type/drivers/list',
      name: 'driversList',
      component: DriverList,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/:type/orders/list',
      name: 'ordersList',
      component: DesignateOrderList,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/checkout/:type',
      name: 'checkout',
      component: Checkout,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/task/:type/:id?',
      name: 'task',
      component: Task,
      meta: {
        scrollToTop: true
      }
    },
    {
      path: '/orders',
      name: 'orders',
      component: OrderList,
      meta: {
        scrollToTop: true,
        keepAlive: true,
      }
    },
    {
      path: '/order/:id',
      name: 'order',
      component: Order,
      meta: {
        scrollToTop: true,
        isReloadOrder: true,
      }
    },
    {
      path: '/order/:id/timeline',
      name: 'timeline',
      component: Timeline,
      meta: {
        scrollToTop: true,
        isReloadOrder: true,
      }
    },
    {
      path: '/share/fail',
      name: 'shareFail',
      component: ShareFail,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/share/:code',
      name: 'share',
      component: Share,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/order/:id/message',
      name: 'message',
      component: Message,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/order/:id/edit',
      name: 'orderEdit',
      component: OrderEdit,
      meta: {
        scrollToTop: true,
        isReloadOrder: true,
      }
    },
    {
      path: '/order/:id/score',
      name: 'score',
      component: Score,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/order/:id/help',
      name: 'help',
      component: Help,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/order/:price/:prepaid/cancel',
      name: 'orderCancel',
      component: Cancel,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/shop/:id/suggest',
      name: 'suggest',
      component: Suggest,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/coupons',
      name: 'coupons',
      component: Coupons,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/notices',
      name: 'notices',
      component: Notices,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/payment/:id',
      name: 'payment',
      component: Payment,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/recommend',
      name: 'recommend',
      component: Recommend,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '/activities',
      name: 'activities',
      component: Activities,
      meta: {
        scrollToTop: true,
      }
    },
    {
      path: '*',
      redirect: {
        name: 'home',
      }
    },
  ],
  scrollBehavior,
  mode: 'history',
  base: '/app/',
});

let isFirst = true;
let originTo = null;
router.beforeEach(async (to, from, next) => {
  const publicPages = ['login', 'home', 'ShopList', 'shop', 'BrandShops', 'AdShops', 'transport', 'buy', 'elastic', 'pay', 'task', 'wait', 'search', 'wash', 'liquorShop', 'share', 'shareFail', 'housekeeping', 'accompanying'];
  const authRequired = !publicPages.includes(to.name);
  const loggedIn = localStorage.getItem('token');

  if (to.query.ot) {
    originTo = {
      replace: true,
      name: to.query.ot,
    }
  }

  if (isFirst) {
    isFirst = false;
    await LIFF(to.query.mini);

    if (store.state.user.isLineMini && !['buy', 'shop', 'ShopList'].includes(to.name)) {
      next({
        replace: true,
        name: 'home',
      })
    }
  }

  if (!loggedIn && authRequired) {
    originTo = R.clone(to);
    return next({
      name: 'login',
    });
  }

  if (to.name === 'home' && store.state.user.isLineMini) {
    return next({
      replace: true,
      name: 'buy',
      query: {
        mini: 1,
      }
    });
  }

  if (originTo && ['login', 'register'].includes(from.name) && to.name === 'home') {
    originTo.replace = true;
    return next(originTo);
  }

  if (store.state.user.isLineMini && ! to.query.mini) {
    let toClone = R.clone(to);
    toClone.replace = from.name === 'checkout';
    toClone.query.mini = 1;
    next(toClone);
  }

  next();
});

export default router;
